var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import OTPValidation from "./OTPValidation";
import di from "../di/index";
import { ERole } from "../Login";
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import BackToLogin from "../common/BackToLogin";
import { useSelector } from "react-redux";
var UnblockAccount = function (props) {
    var _a, _b, _c;
    var _d = __read(React.useState(false), 2), isShowLoader = _d[0], setIsShowLoader = _d[1];
    var _e = __read(React.useState({
        isShowError: false,
        errorMessage: "",
    }), 2), error = _e[0], setError = _e[1];
    var _f = __read(React.useState(), 2), resendOTPDuration = _f[0], setResendOTPDuration = _f[1];
    var currentLoginComponent = useSelector(function (state) { return state.Login.LoginComponentReducer.reducersData; });
    var handleCheckUserStatus = function () {
        setIsShowLoader(true);
        var payload = {
            userName: props.userId,
            loginFor: props.loginFor,
        };
        di.login
            .userUnblockCheck(payload)
            .then(function (resp) {
            setIsShowLoader(false);
            setResendOTPDuration({ minutes: 0, seconds: 60 });
        })
            .catch(function (error) {
            setIsShowLoader(false);
            setError({ isShowError: true, errorMessage: error.getMessage() });
        });
    };
    var handleVerifyUnblockOTP = function (OTP) {
        var _a;
        setIsShowLoader(true);
        var payload = {
            userName: props.userId,
            loginFor: props.loginFor,
            validateotprequestDTO: {
                otpId: (_a = props.userData) === null || _a === void 0 ? void 0 : _a.otpId,
                otp: OTP,
            },
        };
        di.login
            .userUnblock(payload)
            .then(function (resp) {
            if (resp.data) {
                di.login.changeCurrentLoginComponent({
                    currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
                    extraConfig: {
                        currentActiveTab: ERole.Partner,
                        tabMessageClass: "login-success-message",
                        messageIcon: (React.createElement("i", { className: "edel-icon-tick-color-circle" },
                            React.createElement("span", { className: "path1" }),
                            React.createElement("span", { className: "path2" }))),
                        tabMessage: resp.data,
                    },
                });
            }
            setIsShowLoader(false);
        })
            .catch(function (error) {
            setIsShowLoader(false);
            if (typeof error.getErrorData() === "object") {
                setResendOTPDuration({
                    minutes: error.getErrorData()
                        .MaxRequestTime,
                    seconds: 0,
                });
                setError({
                    isShowError: true,
                    errorMessage: error.getMessage(),
                    isShowErrorInHeader: true,
                });
            }
            else {
                setError({
                    isShowError: true,
                    errorMessage: (React.createElement("div", { className: "login-error-message tab-header gap-2 d-flex align-items-center p-10" },
                        React.createElement("i", { className: "edel-icon-validation" }),
                        error.getMessage())),
                    isShowErrorInHeader: false,
                });
            }
        });
    };
    React.useEffect(function () {
        var _a, _b, _c;
        if ((currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) &&
            ((_a = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _a === void 0 ? void 0 : _a.tabMessage)) {
            setError({
                isShowError: true,
                isShowErrorInHeader: true,
                errorMessage: (React.createElement("div", null, currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig.tabMessage)),
            });
        }
        if ((currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) &&
            ((_b = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _b === void 0 ? void 0 : _b.timerDuration)) {
            setResendOTPDuration((_c = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _c === void 0 ? void 0 : _c.timerDuration);
        }
    }, [currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig]);
    return (React.createElement("div", { className: "d-flex flex-column justify-content-start align-items-center w-100 forget-password-container" },
        React.createElement("div", { className: "txt-midnight-blue DMSan_24_700 reset-password-text " }, "Unblock your Partner Account"),
        error.isShowError && error.isShowErrorInHeader && (React.createElement("div", { className: "login-error-message d-flex gap-3 tab-header p-15 mgtb-15" },
            React.createElement("i", { className: "edel-icon-forgot-login" }),
            React.createElement("div", { className: "line-140" }, error.errorMessage))),
        React.createElement(OTPValidation, { userData: {
                email: (_a = props.userData) === null || _a === void 0 ? void 0 : _a.email,
                mobile: (_b = props.userData) === null || _b === void 0 ? void 0 : _b.email,
                otpId: (_c = props.userData) === null || _c === void 0 ? void 0 : _c.otpId,
                message: "",
            }, resendOTPCallback: handleCheckUserStatus, verifyOTPCallback: handleVerifyUnblockOTP, isShowLoader: isShowLoader, error: {
                isShowError: error.isShowError,
                errorMessage: !error.isShowErrorInHeader ? error.errorMessage : "",
            }, timerDuration: resendOTPDuration }),
        React.createElement(BackToLogin, null)));
};
export default UnblockAccount;
